/**
 * Normalizes a date to local midnight for date-only comparison / display.
 *
 * Dates that arrive as UTC midnight (e.g. `new Date('2025-01-01')` or from a
 * server JSON payload) are re-anchored from their UTC year/month/day so the
 * intended calendar date is preserved in any timezone (e.g. UTC-5 / New York
 * would otherwise roll them back to the previous calendar day).
 *
 * Non-UTC-midnight dates are stripped to local midnight using their local
 * year/month/day components.
 *
 * Contract: date-only mode uses local midnight; DateTime mode preserves exact
 * local time and should not call this function.
 */
export const normalizeToLocalMidnight = (date: Date): Date => {
    const isUtcMidnight =
        date.getUTCHours() === 0 &&
        date.getUTCMinutes() === 0 &&
        date.getUTCSeconds() === 0 &&
        date.getUTCMilliseconds() === 0;
    if (isUtcMidnight) {
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    }
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};
